export default __webpack_public_path__ + "static/media/how-we-succeed-2.afc59ef4.jpg";